import React from 'react';
import { Grid, Table } from 'semantic-ui-react';
import moment from 'moment';

import { priceDisplay } from '../../helpers/price';
class BidHistoryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    try {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        
    }
    catch {

    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
  }

  render() {
    const { bidHistory, userHas2PlaceBid, hideheading } = this.props;
    if (!bidHistory) {
      return null;
    }
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <h2>Quote History</h2>
          </Grid.Column>
          <Grid.Column width={16}>
          <Table striped className="regular">
                { this.state.windowWidth >= 768 &&
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Price</Table.HeaderCell>
                      <Table.HeaderCell>Seller</Table.HeaderCell>
                      <Table.HeaderCell>Date/Time</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                }

                  <Table.Body>
                    {bidHistory.map(bh => (
                      <Table.Row key={`${bh.bid.sellerBidHistoryID}_${bh.bid.price}`}>
                        <Table.Cell>
                        {
                          this.state.windowWidth < 768 && <React.Fragment><span>Price: </span><span>{priceDisplay(bh.bid.price)}</span></React.Fragment>
                        }
                        {
                          this.state.windowWidth >= 768 && priceDisplay(bh.bid.price)
                        }
                        </Table.Cell>
                        <Table.Cell>
                        {
                          this.state.windowWidth < 768 && <React.Fragment><span>Seller: </span><span>{bh.seller.name}</span></React.Fragment>
                        }
                        {
                          this.state.windowWidth >= 768 && bh.seller.name
                        }</Table.Cell>
                        <Table.Cell>
                        {
                          this.state.windowWidth < 768 && <React.Fragment><span>Date/Time: </span><span>{bh.bid.bidOn && moment(bh.bid.bidOn).format('LLL')}</span></React.Fragment>
                        }
                        {
                          this.state.windowWidth >= 768 && bh.bid.bidOn && moment(bh.bid.bidOn).format('LLL')
                        }
                        
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      
    );
  }
}
export default BidHistoryComponent;